import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect, } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { IPersona, IDeletePersonaResponse, IUpdatePersonaResponse } from '../../interfaces/personas.interface';
import {
  CreatePersona, CreatePersonaSuccess, DeletePersona, DeletePersonaSuccess,
  GetPersonas, GetPersonasSuccess, UpdatePersona, UpdatePersonaSuccess
} from '../actions/personas.actions';

@Injectable()
export class PersonasEffects {
  getPersonas$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetPersonas),
      switchMap(() =>
        this.apiService.getPersonas().pipe(
          map((personas: IPersona[]) => GetPersonasSuccess({ personas }))
        )
      )
    )
  );

  createPersona$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CreatePersona),
      switchMap(payload =>
        this.apiService.createPersona(payload.persona).pipe(
          map((persona: IPersona) => CreatePersonaSuccess({ persona }))
        )
      )
    )
  );

  deletePersona$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeletePersona),
      switchMap(payload =>
        this.apiService.deletePersona(payload.id).pipe(
          map((persona: IDeletePersonaResponse) => DeletePersonaSuccess({ persona }))
        )
      )
    )
  );

  updatePersona$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UpdatePersona),
      switchMap(payload =>
        this.apiService.updatePersona(payload.id, payload.persona).pipe(
          map((persona: IUpdatePersonaResponse) => UpdatePersonaSuccess({ persona }))
        )
      )
    )
  );

  constructor(
    private apiService: ApiService,
    private actions$: Actions,
    private store: Store<IAppState>
  ) { }
}
